<div class="fullcontainer">
  <br />
  <br />

  <div class='titleContainer noPrint'>
    <h2 class='header' style='color: #006498'>Location Label Sheet</h2>

    <div>
      <button class='btn btn-secondary' (click)='this.print()' [disabled]='this.warehouseLocations.length === 0'><i class="fas fa-print"></i> Print Sheet</button>&nbsp;
      <button class='btn btn-secondary' routerLink='/warehousing/locations'><i class="fas fa-arrow-left"></i> Back</button>&nbsp;
    </div>
  </div>
  <app-label-print-setup></app-label-print-setup>
  <br />

  <div class="form-row noPrint">
    <div class="form-group col-md-4">
      <label>Warehouse</label>
      <select class='form-control' (change)='this.onWarehouseChanged($event.target.value)'>
        <option value='-1'>Select a warehouse</option>
        @for (item of this.warehouses; track item) {
          <option [value]='item.id' [selected]='this.selectedWarehouseId === item.id'>{{ item.name }}</option>
        }
      </select>
    </div>
  </div>

  @if (this.selectedWarehouseId !== -1 && this.warehouseLocations.length === 0) {
    <div class="alert alert-info noPrint">This warehouse has no locations to label.</div>
  }
  <br />

  <div class='labelSheet'>
    @for (item of this.warehouseLocations; track item.id) {
      <app-stock-label
        scanType='location'
        [recordId]='item.id'
        [title]='this.getShelf(item)'
        [subtitle]='this.getWarehouseName(item)'
        [reference]='item.description'
      ></app-stock-label>
    }
  </div>
</div>
